window.addEventListener('DOMContentLoaded', () => {
  const queryValue = getUrlQuery();

  if (queryValue === '') {
    const defaultType = document.querySelector('.js-default-type');
    getMatchingMenus(defaultType.dataset.type);
    setActiveNav(defaultType.dataset.type);
  } else {
    getMatchingMenus(queryValue);
    setActiveNav(queryValue);
  }
});

function getUrlQuery() {
  let query = window.location.search;
  query = query.replace('?type=', '');
  return query;
}

function getMatchingMenus(type) {
  let menus = document.querySelectorAll('.menu[data-type="' + type + '"');
  menus.forEach((menu) => {
    menu.classList.add('menu--active');
  });
}

function setActiveNav(type) {
  document.querySelector('.menu-' + type + '').classList.add('page-navigation__link--active');
}